var map = {
	"./de-DE.json": 33928,
	"./en-GB.json": 51654,
	"./en-US.json": 17167,
	"./es-ES.json": 8054,
	"./fr-CA.json": 33850,
	"./fr-FR.json": 37315,
	"./it-IT.json": 10568,
	"./ja-JP.json": 94304,
	"./ro-RO.json": 19473
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62769;